<script>
import { mapGetters } from 'vuex';
import Filters from '@/helpers/advanced-filters/AdvancedFilters';

export default {
  name: 'AdvancedFilter',

  props: {
    /**
     * The item that needs to be filtered
     */
    item: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      filters: new Filters(),
    };
  },

  computed: {
    ...mapGetters({
      statedFilters: 'filter/filters',
    }),
  },

  mounted() {
    if (Object.keys(this.statedFilters).length) {
      this.setFilters();
    }
  },

  watch: {
    statedFilters() {
      this.filters.resetFilters();
      this.filters.resetItems();

      this.setFilters();
    },
  },

  methods: {
    setFilters() {
      Object.keys(this.statedFilters).forEach((key) => {
        this.filters.addFilter(
          {
            value: { [key]: this.statedFilters[key] },
            type: this.statedFilters[key].type,
          },
        );
      });

      this.filters.addItem(this.item);

      this.filters.validate();
      this.$emit('validation', this.filters.isValid());
    },
  },

  render() {
    return this.$slots.default;
  },
};
</script>
